import styled from 'styled-components';
import { key } from 'styled-theme';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  font-weight: bold;
  font-size: 64px;
  color: ${key('colors.black.light.300')};
  line-height: 50px;

  ${media.moreThan('companyHistoryPlus')`
    position: absolute;
    top: -50px;
    right: calc(100% + 20px);
    padding: 20px;
    background: white;
    text-align: right;
  `};
`;
